import {
  Button,
  Filter,
  Loading,
  SearchBar,
  Typography,
} from "@kitbird/core";
import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import BBLogo from "../../../assets/icons/logogram_bb.png";
import {
  CardContent,
  PageCard,
  PageWrapper,
  TitleContent,
} from "../../../components/Content/Content.style";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import { ActionSection } from "./UserPosition.styled";
import { StickyTable } from "../../../components/Table/Table.style";
import { ReactComponent as FilterIcon } from "../../../assets/icons/filter.svg";
import { Provider, useUserPosition } from "./Provider";
import Table from "../../../components/Table";
import columns from "./columns";
import DeleteModal from "./components/DeleteModal";
import CreateUserModal from "./components/CreateUserModal";
import MutationHistoryPage from "./components/MutationUser/MutationHistoryPage";
import MutationPage from "./components/MutationUser/MutationPage";

const UserPosition = () => {
  const {
    meta,
    params,
    setParams,
    dataPools,
    dataDepartments,
    userList,
    setModal,
    setSelectedRow,
    columnOpts,
    observerRef,
    setColumnOpts,
    hiddenColumn,
    isFetching,
    isFetchingNextPage,
    setMoreActionElem,
    moreActionElem,
    action,
    optionsPool,
    optionsDepartment,
  } = useUserPosition();
  const navigate = useNavigate();

  if (action === "history") return (<MutationHistoryPage />);
  if (action === "mutation") return (<MutationPage />);
  return (
    <>
      <PageWrapper>
        <HeaderText>
          <Typography level={3} fontWeight="medium">
            Master user position
          </Typography>
        </HeaderText>
        <PageCard>
          <CardContent>
            <TitleContent>
              <img src={BBLogo} width={40} alt="" />
              <Typography level={4} fontWeight="medium">
                Daftar user position
              </Typography>
            </TitleContent>
            <ActionSection>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 9,
                }}
              >
                <SearchBar
                  data-testid="search-bar"
                  placeholder="Cari Nama atau NIP"
                  hasReset
                  onInputSearch={(value) => {
                    setParams((curr) => ({ ...curr, search: value }));
                  }}
                />
                <Filter
                  data-testid="filter-column"
                  label="Kolom"
                  options={columnOpts}
                  onSelected={setColumnOpts}
                  icon={<FilterIcon style={{ marginRight: 8 }} />}
                />
                <Filter
                  data-testid="filter-pool"
                  label="Pool"
                  options={optionsPool}
                  onSelected={(opt) => {
                    const value = opt.filter((item) => item.checked);
                    setParams((curr) => ({
                      ...curr,
                      pool: [...value.map((item) => item.value)] as string[],
                    }));
                  }}
                />
                <Filter
                  data-testid="filter-department"
                  label="Departemen"
                  options={optionsDepartment}
                  onSelected={(opt) => {
                    const value = opt.filter((item) => item.checked);
                    setParams((curr) => ({
                      ...curr,
                      department: [...value.map((item) => item.value)] as string[],
                    }));
                  }}
                />
              </div>
              <Button
                leftIcon={<PlusIcon />}
                style={{
                  whiteSpace: "nowrap",
                }}
                onClick={() => setModal("CREATE")}
              >
                Tambah data
              </Button>
            </ActionSection>
            <StickyTable>
              {isFetching && !isFetchingNextPage
                ? <Loading variant="line" />
                : <Table
                  columns={
                    columns(setSelectedRow, setModal, setMoreActionElem, moreActionElem, navigate)
                  }
                  hiddenColumnKeys={hiddenColumn}
                  withNumber
                  dataSource={userList}
                  footer={
                    <>
                      {
                        (!isFetching && meta.page < meta.total_pages && <tfoot ref={observerRef} style={{ height: 5, width: "100%" }} />)
                      }
                    </>
                  }
                />
              }
              {isFetchingNextPage && <Loading variant="circular" />}
            </StickyTable>
          </CardContent>
        </PageCard>
      </PageWrapper>
      <CreateUserModal />
      <DeleteModal />
    </>
  );
};

const UserPositionProvider = () => (
  <Provider>
    <UserPosition />
  </Provider>
);

export default UserPositionProvider;
